import type { FocusPosition } from '@tiptap/react'
import type { EditorView } from 'prosemirror-view'

export interface ClientPoint {
  x: number
  y: number
}

/**
 * The document position under a viewport point, for placing the caret where the user clicked
 * (#25185). A point outside the text (padding, a gap between paragraphs that `posAtCoords` can't
 * map) falls back to the end, which is where a click below the last line would land natively.
 */
export function getFocusPositionAtPoint(
  view: Pick<EditorView, 'posAtCoords'> | undefined,
  point: ClientPoint
): FocusPosition {
  const result = view?.posAtCoords({ left: point.x, top: point.y })
  return result ? result.pos : 'end'
}
